module.exports = __webpack_public_path__ + "img/ic_professional_preference.03557720.svg";